<template>
  <v-layout row wrap align-content-start fill-height class="pa-4">
    <v-flex xs12 class="page-head-container mb-3">
      <v-flex xs12 class="mb-4 page-head-container">
        <h1 class="headline font-weight-light">Antiplatelet List</h1>
      </v-flex>

      <v-flex xs12 class="search-container">
        <v-text-field
          label="Search"
          solo
          flat
          hide-details
          v-model="search"
        ></v-text-field>
      </v-flex>

      <v-flex xs12>
        <template>
          <v-data-table
            v-if="getAntiplatelets.length > 0"
            :headers="headers"
            :items="getAntiplatelets"
            :pagination.sync="pagination"
            :search="search"
            hide-actions
            class="my-4"
            :disable-initial-sort=true >


            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in headers"
                  :key="header.text"
                  :class="['column sortable', pagination.order ? 'desc' : 'asc', header.value === pagination.title ? 'active' : '']"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <tr @click="clickItem(props.item)">
                <td>
                  <v-edit-dialog
                    :return-value.sync="props.item.antiplatelet"
                    lazy
                    @save="updateAntiplatelet(props.item.id, 'antiplatelet', tempItem.antiplatelet)"
                  > {{ props.item.antiplatelet }}
                    <v-text-field
                      slot="input"
                      v-model="tempItem.antiplatelet"
                      label="Edit"
                      single-line
                    ></v-text-field>
                  </v-edit-dialog>
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
      </v-flex>
    </v-flex>

    <v-btn icon fixed bottom right fab color="primary" @click="addAntiplatelet">
      <v-icon>add</v-icon>
    </v-btn>

    <v-snackbar
      v-model="snackbar"
      bottom
      :timeout="timeout"
      color="green"
    >
      New Antiplatelet Added
    </v-snackbar>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'AdminAntiplateletList',
    data() {
      return {
        search: '',
        pagination: {
          rowsPerPage: -1,
          title:'',
          order:false
        },
        headers: [
          {
            text: 'Antiplatelet',
            align: 'left',
            value: 'antiplatelet',
            // sortable: false
          }
        ],
        snackbar: false,
        timeout: 3000,
        tempItem:'',
        tempValue:''
      }
    },

    computed: {
      ...mapGetters('antiplatelets', [
        'getAntiplatelets'
      ])
    },

    created () {
      this.fetchAntiplatelets()
    },

    methods: {
      ...mapActions('antiplatelets', [
        'fetchAntiplatelets'
      ]),
      changeSort (column) {
        if(column===''){return;}
        if (this.pagination.title === column) {
          this.pagination.order = !this.pagination.order
        } else {
          this.pagination.title = column
          this.pagination.order = false
        }
        this.$store.dispatch('antiplatelets/sortAntiplatelet', {title:column,order:this.pagination.order})

      },

      updateAntiplatelet ( antiplateletID, field, value ) {
        // console.log(antiplateletID,field,value)
        const updateObj = {
          antiplateletID: antiplateletID,
          field: field,
          value: value
        }
        
        this.$store.dispatch('antiplatelets/updateColumnById', updateObj)
      },

      async addAntiplatelet () {
        try {
          await this.$store.dispatch('antiplatelets/addAntiplatelet')
          this.snackbar = true
        } catch (e) {
          this.snackbar = false
        }
      },
      clickItem(data){
        this.tempItem = Object.assign({}, data);
      }
    }
  }
</script>

<style lang="scss">
</style>